import {
  TDiscountTableData,
  TDiscountTableDataCalculation,
  TServicesTableDataCalculation,
  TServiceTableData,
} from 'modules/accommodations/features/reservations/models';

export const filteredServicesAndDiscountsStepFour = (
  localstorageTableData: TServiceTableData[] | TDiscountTableData[],
  localstorageAPIData: TServicesTableDataCalculation[] | TDiscountTableDataCalculation[],
) => {
  const filteredIndexes: number[] = [];
  localstorageTableData.forEach(
    (element: TServiceTableData | TDiscountTableData, index: number) => {
      if (!element.objectDefined) {
        filteredIndexes.push(index);
      }
    },
  );

  const filteredDataForAPI: TServicesTableDataCalculation[] | TDiscountTableDataCalculation[] = [];
  filteredIndexes.forEach((servicesFilteredIndex: number) => {
    localstorageAPIData.forEach(
      (
        element: TServicesTableDataCalculation | TDiscountTableDataCalculation,
        currentIndex: number,
      ) => {
        if (servicesFilteredIndex === currentIndex) {
          filteredDataForAPI.push(element as any);
        }
      },
    );
  });

  return filteredDataForAPI;
};
